import { Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RedirectedUserSessionData } from '@airtradeit/authentication';

import { AuthSearchParams } from './init-authentication.interface';
import { AuthService } from '@shared/services/auth/auth.service';

export function initAuthentication(auth: AuthService, router: Router): Observable<null> {
  const url = new URL(window.location.href);
  const { authCode, authState, bearerToken, cultureCode } = getUrlSearchParams(url);
  const isLoginPage = url.pathname.includes('/login');

  if (isLoginPage && authState && authCode) {
    return of(null).pipe(tap(() => router.navigate(['/overview'], { state: { authState, authCode } })));
  } else if (isLoginPage && bearerToken) {
    return of(null).pipe(tap(() => router.navigate(['/overview'], { state: { bearerToken, cultureCode } as RedirectedUserSessionData })));
  } 
  else if (!isLoginPage && !authState && !authCode) {
    return of(null).pipe(tap(() => router.navigate([url.pathname], { state: { bearerToken, cultureCode } as RedirectedUserSessionData })));
  } 
  else if(!isLoginPage && !bearerToken) {
    return auth.retrieveAndStoreSession().pipe(
      map(() => null),
      catchError((e: any) => {
        localStorage.clear();
        router.navigate(['/login']);
        return of(null);
      })
    );
  }
  return of(null);
}

export function getUrlSearchParams(url: URL): AuthSearchParams {
  return {
    authCode: url.searchParams.get('code'),
    authState: url.searchParams.get('state'),
    bearerToken: url.searchParams.get('bearer_token'),
    cultureCode: url.searchParams.get('culture_code'),
  };
}
